import './SwipeAction.less'
import SwipeAction from './SwipeAction'

export type { SwipeActionProps, Action, SwipeActionRef } from './iSwipeAction'

export default SwipeAction
